module.exports = __webpack_public_path__ + "img/call-center-ac@2x.9d1fd15c.png";